import { useEffect } from 'react';
import { setupWebSocketCacheInvalidation } from '../cacheInvalidation';
import frontDeskWebSocket from '../../utils/frontDeskWebSocketClient';

export const useWebSocketCacheInvalidation = () => {
  useEffect(() => {
    const cleanup = setupWebSocketCacheInvalidation(frontDeskWebSocket);

    if (!frontDeskWebSocket.isConnected && !frontDeskWebSocket.isConnecting) {
      frontDeskWebSocket.connect();
    }

    return () => {
      if (cleanup) cleanup();
    };
  }, []);
};

